import { ModalTiteledWindow } from "./modalWindow.js";
import { ModalSelectDate } from "./modalSelectDate.js";
import { NumberSelect } from "../numberSelect.js";
import { MultiSelect } from "../multiSelect.js";
import { AbsentPupilSelect } from "../absentPupilSelect.js";
import { AbsentHomeworkSelect } from "../absentHomeworkSelect.js";
import { RadioButtons } from "../radiobuttons.js";
import "../extend/array.js";
import "../extend/util.js";
import { Validator } from "../validator.js";
import { ModalConfirm } from "./modalConfirm.js";
import { ModAttachment } from "../modAttachment.js";
import { ModalShowAbsentItemsOfCourse } from "./modalShowAbsentItemsOfCourse.js";
import { ModalSpinner } from "../modals/modalSpinner.js";

//import "./extend/dom.js";
export class ModalEditClassRegister extends ModalTiteledWindow {
   constructor(app, data) {

      super();
      this.app = app;
      this.data = {};
      this.data.date = false;
      this.data.absent = [];
      this.dm = app.dm;
      this.user = this.dm.getUserSelf();

      let defaults = {
         date: new Date(),
         studyGroupType: 'course',
      };

      this.set = Object.extend(true, defaults, data);

      let autocorrect = ` autocorrect="${this.dm.clientSettings.get('classRegister.autocorrect', false) ? 'on' : 'off'}"`;

      this.setTitle("Klassenbucheintrag");

      this.elMain = HTMLElement.createFromHTML(
         `<div class="modal-edit-class-register">
            <div class="settings-item info">
               <div class="sync-status"><i class="icon icon-refresh"></i><span class="icon error">!</span></div>
               <div class="message"></div>
            </div>
            <div class="settings-item reg-permission">
               <div class="title">Wer soll den Eintrag sehen können?<span class="help icon-info" selector=".classreg-permission"></span></div>
               <div class="content">
                  <div class="validation-error-message"></div>
               </div>
            </div>
            <div class="settings-item reg-hour">
               <div class="title date"><span>Termin: <span class="date-value"></span></span><span class="help icon-info" selector=".classreg-date"></span></div>
               <div class="content">
                  <div class="date"></div>
                  <div class="validation-error-message"></div>
                  <div class="hour"></div>
               </div>
            </div>
            <div class="settings-item reg-study-group">
               <div class="title"><span>Lerngruppen <span class="study-group-value"></span></span><span class="help icon-info" selector=".classreg-study-group"></span></div>
               <div class="content">
                  <div class="study-group-type"></div>
                  <div class="validation-error-message"></div>
                  <div class="study-group"></div>
               </div>
            </div>
            <div class="settings-item reg-title">
               <div class="title">Fach/Kurstitel</div>
               <div class="content">
                  <div class="validation-error-message"></div>
                  <input type="text" class="txt-title"${autocorrect}></input>
               </div>
            </div>
            <div class="settings-item reg-content">
               <div class="title">Thema
                  <span>
                     <span class="visibility">
                        <input id="modal-edit-class-register-content-visible" type="checkbox" class="switch small">
                        <label for="modal-edit-class-register-content-visible"></label><label for="modal-edit-class-register-content-visible"><i class="icon-eye"></i> abw. SuS</label>
                     </span>
                     <span class="help icon-info" selector=".classreg-content"></span>
                  </span>
               </div>
               <div class="content">
                  <div class="validation-error-message"></div>
                  <textarea rows="3" type="text" class="reg-content"${autocorrect}></textarea>
               </div>
            </div>
            <div class="settings-item reg-homework">
               <div class="title">Hausaufgabe
                  <span>
                     <span class="visibility">
                        <input id="modal-edit-class-register-homework-visible" type="checkbox" class="switch small">
                        <label for="modal-edit-class-register-homework-visible"></label><label for="modal-edit-class-register-homework-visible"><i class="icon-eye"></i> SuS</label>
                     </span>
                     <span class="help icon-info" selector=".classreg-homework"></span>
                  </span>
               </div>
               <div class="content">
                  <textarea rows="3" type="text" class="reg-homework"${autocorrect}></textarea>
               </div>
            </div>
            <div class="settings-item reg-notes">
               <div class="title">Bemerkungen
                  <span>
                     <span class="visibility">
                        <input id="modal-edit-class-register-notes-visible" type="checkbox" class="switch small">
                        <label for="modal-edit-class-register-notes-visible"></label><label for="modal-edit-class-register-notes-visible"><i class="icon-eye"></i> SuS</label>
                     </span>
                     <span class="help icon-info" selector=".classreg-notes"></span>
                  </span>
                  
               </div>
      
               <div class="content">
                  <textarea rows="3" type="text" class="reg-notes"${autocorrect}></textarea>
               </div>
            </div>
            <div class="settings-item reg-absent">
               <div class="title absent">Abwesende SuS (nur MSS)<span class="help icon-info" selector=".classreg-absent"></span></div>
               <div class="content">
                  <div class="absent"></div>
               </div>
            </div>
            <div class="settings-item reg-absent-homework">
               <div class="title absent-homework">Versäumte Hausaufgaben<span class="help icon-info" selector=".classreg-absent-homework"></span></div>
               <div class="content">
                  <i class="button icon-chart-bar"></i>
                  <div class="absent-homework"></div>
               </div>
            </div>
            <div class="settings-item reg-absent-material">
               <div class="title absent-homework">Fehlende Arbeitsmaterialien<span class="help icon-info" selector=".classreg-absent-material"></span></div>
               <div class="content">
                  <i class="button icon-chart-bar"></i>
                  <div class="absent-material"></div>
               </div>
            </div>
            <div class="settings-item reg-attachment">
               <div class="title">Dateianhänge<span class="help icon-info" selector=".classreg-attachment"></span></div>
               <input type="file" class="file-open" name="file" accept="*" multiple="multiple" style="display: none;"></input>

               <div class="content">
                  <div class="attachment-type"></div>
                  <div class="validation-error-message"></div>
                  <div class="attachment"></div>
               </div>

            </div>

            <div class="buttons bottom-bar">
               <i class="btn-delete icon-trash button-circle"></i>
               <!--<i class="btn-copy icon-copy button-circle"></i>-->
               <i class="btn-save icon-check button-circle"></i>
            </div>
         </div>`
      );

      // Buttons zum Löschen und Speichern aktivieren / deaktivieren
      if (this.set.creatorId === this.user.id) {
         this.elMain.querySelector('.btn-save').onclick = () => this.save();

         if (this.set.syncStatus === 'update') {
            this.elMain.querySelector('.info .sync-status').classList.add('update');
            this.elMain.querySelector('.info .message').innerHTML = "Dieser Eintrag wurde noch nicht synchronisiert.";
         }
         else if (this.set.syncStatus === 'error') {
            this.elMain.querySelector('.info .sync-status').classList.add('error');
            this.elMain.querySelector('.info .message').innerHTML = "Fehler beim Synchronisieren: " + this.set.errorMessage;
         }
         else {
            this.elMain.querySelector('.info').style.display = 'none';
         }
   
      }
      else {
         this.elMain.querySelector('.btn-save').style.filter = 'grayscale(1) brightness(1.5)';
         this.elMain.querySelector('.info').style.display = 'none';
      }

      if (this.set.creatorId === this.user.id && this.set.localId) {
         this.elMain.querySelector('.btn-delete').onclick = () => this.delete();
      }
      else {
         this.elMain.querySelector('.btn-delete').style.filter = 'grayscale(1) brightness(1.5)';
      }

      // Sichtbar für
      this.permissionPupils = new RadioButtons('permission-pupils', {  },
         [
               { label: "keine SuS",     value: "NONE" },
               { label: "abwesende SuS", value: "PUPILS_ABSENT" },
               { label: "alle SuS",      value: "PUPILS_OF_COURSE" }
         ]
      );
      if (this.set.new) this.permissionPupils.setValue(this.dm.clientSettings.get('classRegister.defaults.permissionPupils', 'NONE'));
      this.elMain.querySelector('.settings-item.reg-permission .content').prepend(this.permissionPupils.getElement());

      this.permissionTeachers = new RadioButtons('permission-teachers', {  },
         [
               { label: "nur ich",              value: "NONE" },
               { label: "Lehrer dieser Klasse", value: "TEACHERS_OF_CLASS" },
               { label: "alle Lehrer",          value: "TEACHERS_ALL" }
         ]
      );
      if (this.set.new) this.permissionTeachers.setValue(this.dm.clientSettings.get('classRegister.defaults.permissionTeachers', 'NONE'));
      this.elMain.querySelector('.settings-item.reg-permission .content').prepend(this.permissionTeachers.getElement());

      this.elVisibleItems = {
         content:  this.elMain.querySelector('#modal-edit-class-register-content-visible'),
         homework: this.elMain.querySelector('#modal-edit-class-register-homework-visible'),
         notes:    this.elMain.querySelector('#modal-edit-class-register-notes-visible')
      };

      this.elVisibleItems.content.checked = this.dm.clientSettings.get('classRegister.defaults.contentVisible', true);
      this.elVisibleItems.homework.checked = this.dm.clientSettings.get('classRegister.defaults.homeworkVisible', true);
      this.elVisibleItems.notes.checked = this.dm.clientSettings.get('classRegister.defaults.notesVisible', true);

      // freeEdit
      /*
      this.freeEdit = new RadioButtons('free-edit',
         {  },
         [
               { label: "Ja",   value: "yes" },
               { label: "Nein", value: "no" },
         ]
      );
      this.freeEdit.setValue('no');
      this.elMain.querySelector('.settings-item.reg-free-edit .content').prepend(this.freeEdit.getElement());
      */

      // Datum
      this.elDate = this.elMain.querySelector('.date .date-value');
      this.elDate.onclick = (event) => {
         let ed = new ModalSelectDate({ range: false, onSelect: (date) => this.setDate(date) });
         ed.setDate(this.data.date);
         event.stopPropagation();
      }

      // Stunde
      this.hourSelect = new NumberSelect({
         onChange: (sel) => sel ? this.setHour({ from: sel.from+1, to: sel.to+1 }) : false,
         max: 12,
         columns: 6,
         selectRange: true,
         getNumberTitle: number => number + 1
      });
      this.elMain.querySelector('.hour').appendChild(this.hourSelect.getElement());

      // Lerngruppentyp
      this.studyGroupType = new RadioButtons('study-group-type',
         { onSelect: (value) => this.setStudyGroupType(value) },
         [
               { label: "Kurs", value: "course" },
               { label: "Klasse", value: "class" }
         ]
      );
      this.elMain.querySelector('.content .study-group-type').appendChild(this.studyGroupType.getElement());

      // Lerngruppen
      this.studyGroupCourse = new MultiSelect({
         listTitle: "Kurs wählen",
         getItems: () => this.getCourseList(),
         onChange: (courses) => this.setStudyGroups(courses),
         itemTextValue: (course) => course.classNames + ' ' + course.short + ' (' + course.teachers.map(id => this.dm.getUser(id).short).join(',') + ')',
         itemSortValue: (course) => course.classNames.replace(/^(\d[^\d])/, "0$1") + ' ' + course.short,
         itemId: (course) => course.id,
         listSettings: {
               columns: [
                  { title: '', data: (course) => course.classNames, class: () => 'equal-width' },
                  { title: '', data: (course) => course.short, class: () => 'equal-width' },
                  { title: '', data: (course) => course.teachers.map(id => this.dm.getUser(id).short).join(','), class: () => 'equal-width' }
               ]
            }            
      });

      this.studyGroupClass = new MultiSelect({
         listTitle: "Klasse wählen",
         getItems: () => this.getClassList(),
         onChange: (classes) => this.setStudyGroups(classes),
         itemTextValue: (cls) => cls.name,
         itemSortValue: (cls) => cls.name.replace(/^(\d[^\d])/, "0$1"),
         itemId: (cls) => cls.id,
         listSettings: {
               columns: [
                  { title: '', data: (cls) => cls.name, class: () => 'equal-width' }
               ]
            }            
      });

      this.elMain.querySelector('.content .study-group').appendChild(this.studyGroupCourse.getElement());
      this.elMain.querySelector('.content .study-group').appendChild(this.studyGroupClass.getElement());

      // Abwesende Schüler
      this.absentOfCourses = new AbsentPupilSelect({
         getItems: () => this.getPupils(),
         onChange: (pupils) => this.setAbsent(pupils),
         itemTextValue: (pupil) => pupil.lastName + ', ' + pupil.firstName,
         itemSortValue: (pupil) => pupil.lastName + ', ' + pupil.firstName,
         itemId: (pupil) => pupil.id,
         listSettings: {
               columns: [
                  {
                     title: 'Klasse',
                     data: (pupil) => this.dm.getClassName(pupil.classId),
                     sort: { index: 1, dir: 1, value: function(pupil) {
                           return (pupil.class.name.search(/^\d\d/) === -1) ? '0' + pupil.class.name : pupil.class.name;
                     }}
                  },
                  { title: 'Nachname', data: (pupil) => pupil.lastName,  sort: { index: 2, dir: 1} },
                  { title: 'Vorname', data: (pupil) => pupil.firstName,  sort: { index: 3, dir: 1} }
               ]
            }            
      }, this.data);        

      this.absentOfClasses = new AbsentPupilSelect({
         getItems: () => this.getPupils(),
         onChange: (pupils) => this.setAbsent(pupils),
         itemTextValue: (pupil) => pupil.lastName + ', ' + pupil.firstName,
         itemSortValue: (pupil) => pupil.lastName + ', ' + pupil.firstName,
         itemId: (pupil) => pupil.id,
         listSettings: {
               columns: [
                  {
                     title: 'Klasse',
                     data: (pupil) => this.dm.getClassName(pupil.classId),
                     sort: { index: 1, dir: 1, value: function(pupil) {
                           return (pupil.class.name.search(/^\d\d/) === -1) ? '0' + pupil.class.name : pupil.class.name;
                     }}
                  },
                  { title: 'Nachname', data: (pupil) => pupil.lastName,  sort: { index: 2, dir: 1} },
                  { title: 'Vorname', data: (pupil) => pupil.firstName,  sort: { index: 3, dir: 1} }
               ]
            }            
      }, this.data);

      this.elMain.querySelector('.content .absent').appendChild(this.absentOfCourses.getElement());
      this.elMain.querySelector('.content .absent').appendChild(this.absentOfClasses.getElement());

      // Nicht erledigte Hausaufgaben
      this.absentHomework = new AbsentHomeworkSelect({
         getItems: () => this.getPupils(),
         itemTextValue: (pupil) => pupil.lastName + ', ' + pupil.firstName,
         itemSortValue: (pupil) => pupil.lastName + ', ' + pupil.firstName,
         itemId: (pupil) => pupil.id,
         listSettings: {
            columns: [
               {
                  title: 'Klasse',
                  data: (pupil) => this.dm.getClassName(pupil.classId),
                  sort: { index: 1, dir: 1, value: function(pupil) {
                        return (pupil.class.name.search(/^\d\d/) === -1) ? '0' + pupil.class.name : pupil.class.name;
                  }}
               },
               { title: 'Nachname', data: (pupil) => pupil.lastName,  sort: { index: 2, dir: 1} },
               { title: 'Vorname', data: (pupil) => pupil.firstName,  sort: { index: 3, dir: 1} }
            ]
         }            
      });

      this.elMain.querySelector('.content .absent-homework').appendChild(this.absentHomework.getElement());

      this.elMain.querySelector('.reg-absent-homework .icon-chart-bar').onclick = () => {
         if (this.dm.online) {
            let courseIds = this.studyGroupCourse.getSelectedItemIds();
            if (courseIds.length > 0) {
               new ModalShowAbsentItemsOfCourse('homework', 'Versäumte Hausaufgaben', this.app, courseIds[0]);
            }
         }
         else {
            toast.message("Für diese Aktion ist eine Internetverbindung erforderlich.");
         }
      }

      // Fehlende Arbeitsmaterialien
      this.absentMaterial = new AbsentHomeworkSelect({
         getItems: () => this.getPupils(),
         itemTextValue: (pupil) => pupil.lastName + ', ' + pupil.firstName,
         itemSortValue: (pupil) => pupil.lastName + ', ' + pupil.firstName,
         itemId: (pupil) => pupil.id,
         listSettings: {
            columns: [
               {
                  title: 'Klasse',
                  data: (pupil) => this.dm.getClassName(pupil.classId),
                  sort: { index: 1, dir: 1, value: function(pupil) {
                        return (pupil.class.name.search(/^\d\d/) === -1) ? '0' + pupil.class.name : pupil.class.name;
                  }}
               },
               { title: 'Nachname', data: (pupil) => pupil.lastName,  sort: { index: 2, dir: 1} },
               { title: 'Vorname', data: (pupil) => pupil.firstName,  sort: { index: 3, dir: 1} }
            ]
         }            
      });

      this.elMain.querySelector('.content .absent-material').appendChild(this.absentMaterial.getElement());

      this.elMain.querySelector('.reg-absent-material .icon-chart-bar').onclick = () => {
         if (this.dm.online) {
            let courseIds = this.studyGroupCourse.getSelectedItemIds();
            if (courseIds.length > 0) {
               new ModalShowAbsentItemsOfCourse('material', 'Fehlende Arbeitsmaterialien', this.app, courseIds[0]);
            }
         }
         else {
            toast.message("Für diese Aktion ist eine Internetverbindung erforderlich.");
         }
      }
   
      // Titel
      this.elTitle = this.elMain.querySelector('.reg-title .txt-title');
      this.elTitle.onkeyup = (value) => this.setRegTitle(this.elTitle.value);

      this.elContent = this.elMain.querySelector('.reg-content textarea');
      this.elHomework = this.elMain.querySelector('.reg-homework textarea');
      this.elNotes = this.elMain.querySelector('.reg-notes textarea');

      // Attachments
      this.attachments = new ModAttachment({
         maxFileSize: 10485760,

      }, this.app);

      this.elMain.querySelector('.reg-attachment .content .attachment').appendChild(this.attachments.getElement());

      //this.elMain.querySelector('.btn-attachment').onclick = () => this.elMain.querySelector('.file-open').click();
      //this.elMain.querySelector('.file-open').onchange = (event) => this.loadAttachments(event);




      this.loadData(this.set);
      this.appendToBody(this.elMain);
      this.setupHelp(this.app);
      setTimeout(() => this.show(), 1);
   }

   save() {

      let val = new Validator([
         {
               name: 'permission',
               element: this.elMain.querySelector('.settings-item.reg-permission'),
               get: () => [ this.permissionPupils.getValue(), this.permissionTeachers.getValue() ]
         },
         {
            name: 'visibleItems',
            get: () => {
               let items = [];
               if (this.elVisibleItems.content.checked)  items.push('CONTENT');
               if (this.elVisibleItems.homework.checked) items.push('HOMEWORK');
               if (this.elVisibleItems.notes.checked)    items.push('NOTES');
               return items;
            }
         },

         /*
         {
               name: 'freeEdit',
               element: this.freeEdit.getElement(),
               get: () => this.freeEdit.getValue() === 'yes' ? true : false,
         },
         */
         {
               name: 'title',
               element: this.elTitle,
               get: () => this.data.title,
               validate: { 'strMinLen': 1 },
               error: { element: this.elMain.querySelector('.reg-title .validation-error-message'), message: "Bitte geben Sie Fach oder Kurstitel an." }
         },
         {
               name: 'content',
               element: this.elContent,
               get: () => encodeHTMLEntities(this.elContent.value),
               //validate: { 'strMinLen': 0 },
               //error: { element: this.elMain.querySelector('.reg-content .validation-error-message'), message: "Bitte geben Sie das Stundenthema an." }
         },
         {
               name: 'homework',
               get: () => encodeHTMLEntities(this.elHomework.value)
         },
         {
               name: 'notes',
               get: () => encodeHTMLEntities(this.elNotes.value)
         },
         {
               name: 'hour',
               element: this.hourSelect.getElement(),
               get: () => this.data.hour,
               validate: { 'true': null },
               error: { element: this.elMain.querySelector('.reg-hour .validation-error-message'), message: "Bitte geben Sie die Unterrichtsstunde(n) an." }
         },
         {
               name: 'studyGroups',
               element: this.elMain.querySelector('.content .study-group'),
               get: () => this.data.studyGroups.map(item => item.id),
               validate: { 'arrayMinLen': 1 },
               error: { element: this.elMain.querySelector('.reg-study-group .validation-error-message'), message: "Bitte wählen Sie mindestens eine Lerngruppe." }
         },
         {
               name: 'studyGroupType',
               get: () => this.data.studyGroupType
         },
         {
               name: 'date',
               get: () => this.data.date.isoDate()
         },
         {
               name: 'absent',
               get: () => {
                  let absent = this.data.absent.map(item =>  {
                     let absent = { type: 'pupil', id: item.data.id, justified: !!item.info.justified, value: Math.min(item.info.value, this.data.hourSpan) };
                     if (item.info.note) absent.note = item.info.note;
                     return absent;
                  })
                  .concat(
                     this.absentHomework.getSelectedItems().map(item => {
                        return { type: 'homework', id: item.data.id, value: item.info.value };
                     })
                  )
                  .concat(
                     this.absentMaterial.getSelectedItems().map(item => {
                        return { type: 'material', id: item.data.id, value: item.info.value };
                     })
                  );
                  return absent;
               }
               
         },
         {
               name: 'attachment',
               get: () => this.attachments.getSelectedItemIds()
         }           
      ]);

      let valiData = val.validate();

      if (valiData) {

         let data = Object.extend(true, this.set, valiData);
         delete data['new'];
         if (!data.creatorId) data.creatorId = this.user.id;
         this.close();

         const spinner = new ModalSpinner("Speichere Eintrag");
         this.dm.saveClassRegister(data)
         .then(() => {
            this.app.classReg.redrawBuffer();
         })
         .finally(() => {
            spinner.close();
         });
      }

   }

   delete() {

      if (!this.set.localId && !this.set.freeEdit) return;

      new ModalConfirm(
         "Soll dieser Klassenbucheintrag wirklich gelöscht werden?",
         async (confirmed) => {
               if (confirmed) {
                  await this.dm.deleteClassRegister(this.set);
                  this.app.classReg.redrawBuffer();
                  this.close();
               }
         }
      );

   }

   getCourseList() {
      return {
         list:    this.dm.getCourses().filter(course => !course.teachers.includes(this.user.id)),
         favList: this.dm.getCourses().filter(course => course.teachers.includes(this.user.id))
      };
   }

   getClassList() {
      let classes = Object.values(this.dm.getClasses());
      return {
         list:    classes.filter(cls => !cls.teachers.find(t => t.id === this.user.id)),
         favList: classes.filter(cls => cls.teachers.find(t => t.id === this.user.id)),
      };
   }

   getPupils() {

      let pupilIds = [];

      for (let course of this.data.studyGroups) pupilIds = pupilIds.concat(course.pupils);

      return { 
         list: pupilIds.unique().map(id => this.dm.getPupil(id)), 
         favList: []
      };

   }

   updateDate() {

      let dateStr = '<span class="selected-date">' + (this.data.date.isSameDay(new Date()) ? 'heute' : this.data.date.toGermanDate(true, true)) + '</span>';

      if (this.data.hour) {
         dateStr += ', ' +  (this.data.hour.from === this.data.hour.to ? this.data.hour.from : this.data.hour.from + '-' + this.data.hour.to) + '. Std.';
      }
      this.elDate.innerHTML = dateStr;

   }

   setRegTitle(title) {
      this.data.title = title;
      this.elTitle.value = title;
   }

   setRegContent(content) {
      this.data.content = decodeHTMLEntities(content);
      this.elContent.value = decodeHTMLEntities(content);
   }

   setRegHomework(homework) {
      this.data.homework = decodeHTMLEntities(homework);
      this.elHomework.value = decodeHTMLEntities(homework);
   }

   setRegNotes(notes) {
      this.data.notes = decodeHTMLEntities(notes);
      this.elNotes.value = decodeHTMLEntities(notes);
   }

   setHour(hour) {
      const hourSpan = (hour.to - hour.from) + 1;
      this.data.hour = hour;
      this.data.hourSpan = hourSpan;
      this.updateDate();
   }

   setDate(date) {
      this.data.date = date;
      this.updateDate();
   }

   setStudyGroupType(type) {
      this.data.studyGroupType = type;

      if (type === 'course') {
         this.studyGroupCourse.getElement().style.display =  'grid';
         this.studyGroupClass.getElement().style.display  = 'none';
         this.absentOfCourses.getElement().style.display = 'grid';
         this.absentOfClasses.getElement().style.display = 'none';
         this.setStudyGroups(this.studyGroupCourse.getSelectedItems());
      }
      else {
         this.studyGroupCourse.getElement().style.display =  'none';
         this.studyGroupClass.getElement().style.display  = 'grid';
         this.absentOfCourses.getElement().style.display = 'none';
         this.absentOfClasses.getElement().style.display = 'grid';
         this.setStudyGroups(this.studyGroupClass.getSelectedItems());
      }
   }

   setStudyGroups(studyGroups) {
      this.data.studyGroups = studyGroups;
      this.updateStudyGroupTitle();
      this.updateAbsent();
   }

   updateAbsent() {

      // Schüler ermitteln, die in den ausgewählten Klassen/Kursen sind
      let coursePupils = this.data.studyGroups.reduce((pupils, current) => pupils = pupils.concat(current.pupils), []);

      // Ids der Schüler herausfiltern, die selektiert und in diesen Klassen /Kursen sind
      let selectedPupils = this.data.absent.filter(absent => coursePupils.includes(absent.id))
      .map(item => {
         return { id: item.id, info: { justified: item.justified, value: item.value, note: item.note } };
      });        
      
      // Neue Auswahl treffen
      if (this.data.studyGroupType === 'course') this.absentOfCourses.setSelection(selectedPupils);
      else this.absentOfClasses.setSelection(selectedPupils);

   }

   updateAbsentHomework(absent) {

      // Schüler ermitteln, die in den ausgewählten Klassen/Kursen sind
      let coursePupils = this.data.studyGroups.reduce((pupils, current) => pupils = pupils.concat(current.pupils), []);

      // Ids der Schüler herausfiltern, die selektiert und in diesen Klassen /Kursen sind
      let selectedPupils = absent.filter(absent => coursePupils.includes(absent.id))
      .map(item => {
         return { id: item.id, info: { value: item.value, note: item.note } };
      });        
      
      // Neue Auswahl treffen
      this.absentHomework.setSelection(selectedPupils);

   }   

   updateAbsentMaterial(absent) {

      // Schüler ermitteln, die in den ausgewählten Klassen/Kursen sind
      let coursePupils = this.data.studyGroups.reduce((pupils, current) => pupils = pupils.concat(current.pupils), []);

      // Ids der Schüler herausfiltern, die selektiert und in diesen Klassen /Kursen sind
      let selectedPupils = absent.filter(absent => coursePupils.includes(absent.id))
      .map(item => {
         return { id: item.id, info: { value: item.value, note: item.note } };
      });        
      
      // Neue Auswahl treffen
      this.absentMaterial.setSelection(selectedPupils);

   }   

   updateStudyGroupTitle() {

      let groupStr = '';
      if (this.data.studyGroupType === 'course') {
         groupStr = this.data.studyGroups
         .map(course => { 
               return course.classNames + ' ' + course.short + ' (' + course.teachers.map(id => this.dm.getUser(id).short).join(',') + ')';
         })
         .join(', ');
      }
      else {
         groupStr = this.data.studyGroups.map(cls => cls.name).join(', ');
      }
      let elGroupTitle = this.elMain.querySelector('.reg-study-group .title .study-group-value');
      elGroupTitle.innerHTML = groupStr;

   }

   setAbsent(pupils) {
      this.data.absent = pupils;
   }

   setPermission(permission) {

      if (!permission) return;

      this.permissionPupils.setValue('NONE')
      this.permissionTeachers.setValue('NONE')

      for (let flag of permission) {
         if      (flag === 'PUPILS_ABSENT')     this.permissionPupils.setValue(flag);
         else if (flag === 'PUPILS_OF_COURSE')  this.permissionPupils.setValue(flag);
         else if (flag === 'TEACHERS_OF_CLASS') this.permissionTeachers.setValue(flag);
         else if (flag === 'TEACHERS_ALL')      this.permissionTeachers.setValue(flag);
         else if (flag === 'NONE')              {}
         else toast.alert("Unbekanntes flag: " + flag, { duration: 8000 });
      }
      
   }

   setItemVisibility(visibileItems) {

      if (!visibileItems) return false;

      for (let item in this.elVisibleItems) this.elVisibleItems[item].checked = false;

      for (let flag of visibileItems) {
         if      (flag === 'CONTENT')  this.elVisibleItems.content.checked = true;
         else if (flag === 'HOMEWORK') this.elVisibleItems.homework.checked = true;
         else if (flag === 'NOTES')    this.elVisibleItems.notes.checked = true;
      }

   }   

   loadData(data) {

      if (data.date) {
         this.data.date = data.date;
         this.updateDate();
      }

      this.setHour({ from: data.hour.from, to: data.hour.to });
      this.setPermission(data.permission);
      this.setItemVisibility(data.visibleItems);

      if (data.freeEdit) {
         this.freeEdit.setValue(data.freeEdit ? 'yes' : 'no');
      }

      if (data.hour) {
         this.hourSelect.setSelection(data.hour.from-1, data.hour.to-1);
      }
      if (data.studyGroupType) {
         this.studyGroupType.setValue(data.studyGroupType);
      }
      if (data.studyGroups) {
         //let studyGroups = data.studyGroups.map(item => { return { id: item }; });
         if (this.data.studyGroupType === 'course') this.studyGroupCourse.setSelection(data.studyGroups);
         else this.studyGroupClass.setSelection(data.studyGroups);
      }
      if (data.attachment) {
         this.attachments.setSelection(data.attachment);
      }
      
      if (data.title)    this.setRegTitle(data.title);
      if (data.content)  this.setRegContent(data.content);
      if (data.homework) this.setRegHomework(data.homework);
      if (data.notes)    this.setRegNotes(data.notes);
      if (data.absent) {
         this.setAbsent(data.absent.filter(item => item.type === 'pupil'));
         this.updateAbsentHomework(data.absent.filter(item => item.type === 'homework'));
         this.updateAbsentMaterial(data.absent.filter(item => item.type === 'material'));
         this.updateAbsent();
      }
      
   }


}

